var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money-grow-grown-protect-hand"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.28 48.71 13.24-7.64a4 4 0 0 1 4 6.93l-21.59 12.46a3.925 3.925 0 0 1 -2 .54h-12.37a4.109 4.109 0 0 1 -1.1-.15l-13.46-3.85v-15h10.51a5.993 5.993 0 0 1 4.25 1.76l3.24 3.24h12a4.025 4.025 0 0 1 2.83 1.17 5.852 5.852 0 0 1 .45.54z",
    fill: "#ffc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38 3h6a6 6 0 0 1 -6 6h-6a6 6 0 0 1 6-6z",
    fill: "#9cdd05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38 13h6a6 6 0 0 1 -6 6h-6a6 6 0 0 1 6-6z",
    fill: "#9cdd05"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 33,
    fill: "#ffcd00",
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 9h-6a6 6 0 0 1 -6-6h6a6 6 0 0 1 6 6z",
    fill: "#9cdd05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 19h-6a6 6 0 0 1 -6-6h6a6 6 0 0 1 6 6z",
    fill: "#9cdd05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 57v4h-6v-22h6v3z",
    fill: "#2488ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 33a10 10 0 0 1 -10 10 9.049 9.049 0 0 1 -1.48-.12 10 10 0 0 0 0-19.76 9.049 9.049 0 0 1 1.48-.12 10 10 0 0 1 10 10z",
    fill: "#ddb200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44 3a6 6 0 0 1 -6 6h-4a6 6 0 0 0 6-6z",
    fill: "#5eac24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44 13a6 6 0 0 1 -6 6h-4a6 6 0 0 0 6-6z",
    fill: "#5eac24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.98 46.54a4.007 4.007 0 0 0 -5.46-1.47l-9.52 5.49-3.72 2.15a5.852 5.852 0 0 0 -.45-.54 4.025 4.025 0 0 0 -2.83-1.17h-12l-3.24-3.24a5.993 5.993 0 0 0 -4.25-1.76h-10.51v-4h10.51a5.993 5.993 0 0 1 4.25 1.76l3.24 3.24h12a4.025 4.025 0 0 1 2.83 1.17 5.852 5.852 0 0 1 .45.54l3.72-2.15 9.52-5.49a4 4 0 0 1 5.46 5.47z",
    fill: "#ffa733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 27v1.184a2.993 2.993 0 0 0 1 5.816 1 1 0 1 1 -1 1h-2a3 3 0 0 0 2 2.816v1.184h2v-1.184a2.993 2.993 0 0 0 -1-5.816 1 1 0 1 1 1-1h2a3 3 0 0 0 -2-2.816v-1.184z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38 20a7.008 7.008 0 0 0 7-7 1 1 0 0 0 -1-1h-6a6.97 6.97 0 0 0 -5 2.11v-4.11h5a7.008 7.008 0 0 0 7-7 1 1 0 0 0 -1-1h-6a6.986 6.986 0 0 0 -6 3.41 6.986 6.986 0 0 0 -6-3.41h-6a1 1 0 0 0 -1 1 7.008 7.008 0 0 0 7 7h5v4.11a6.97 6.97 0 0 0 -5-2.11h-6a1 1 0 0 0 -1 1 7.008 7.008 0 0 0 7 7h5v2.05a11 11 0 1 0 2 0v-2.05zm0-6h4.9a5.009 5.009 0 0 1 -4.9 4h-4.9a5.009 5.009 0 0 1 4.9-4zm0-10h4.9a5.009 5.009 0 0 1 -4.9 4h-4.9a5.009 5.009 0 0 1 4.9-4zm-12 4a5.009 5.009 0 0 1 -4.9-4h4.9a5.009 5.009 0 0 1 4.9 4zm0 10a5.009 5.009 0 0 1 -4.9-4h4.9a5.009 5.009 0 0 1 4.9 4zm15 15a9 9 0 1 1 -9-9 9.014 9.014 0 0 1 9 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 2h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 6h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 4h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 4h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 14h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 18h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 16h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 16h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 26h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 30h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 28h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 28h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58 2h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58 6h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60 4h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 4h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52 14h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52 18h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 16h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 16h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58 26h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58 30h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60 28h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 28h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.85 42.04a5.02 5.02 0 0 0 -6.83-1.84l-12.52 7.23a5.009 5.009 0 0 0 -3.5-1.43h-11.59l-2.94-2.95a7 7 0 0 0 -4.96-2.05h-9.51v-2a1 1 0 0 0 -1-1h-6a1 1 0 0 0 -1 1v22a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2.67l12.19 3.48a5.208 5.208 0 0 0 1.37.19h12.37a4.982 4.982 0 0 0 2.5-.67l21.59-12.46a5 5 0 0 0 1.83-6.83zm-53.85 17.96h-4v-20h4zm52.42-14.69a2.986 2.986 0 0 1 -1.4 1.82l-21.59 12.47a3.062 3.062 0 0 1 -1.5.4h-12.37a2.805 2.805 0 0 1 -.82-.12l-12.74-3.63v-13.25h9.51a4.945 4.945 0 0 1 3.54 1.47l3.24 3.24a1.033 1.033 0 0 0 .71.29h12a2.956 2.956 0 0 1 2.1.86 4.479 4.479 0 0 1 .36.42 3.045 3.045 0 0 1 .54 1.72 3.009 3.009 0 0 1 -3 3h-12v2h12a4.97 4.97 0 0 0 4.61-6.9l12.41-7.16a3 3 0 0 1 4.4 3.37z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyGrowth);
export default __webpack_public_path__ + "static/media/money-growth.3d375d0b3da134fc7ff326b627a91aee.svg";
export { ForwardRef as ReactComponent };